module.exports = __webpack_public_path__ + "static/media/10_after.f422a2b7.jpg";